"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Sample_1 = __importDefault(require("./Sample"));
const axios_1 = __importDefault(require("axios"));
class Parcel {
    constructor(raw) {
        this.samples = [];
        this.id = raw.id;
        this.name = raw.name;
        this.parcel_str = raw.parcel_str || null;
        this.samples = raw.samples.map((rawsample) => {
            return new Sample_1.default(rawsample, this);
        });
    }
    static async all(config = {}) {
        const params = {
            add_raw_rank_flag: config.add_raw_rank_flag || false,
            add_sample_location: config.add_sample_location || false,
        };
        const response = (await axios_1.default.get('/toolkit/common/api/parcels', { params })).data;
        return response.map((rawparcel) => {
            return new Parcel(rawparcel);
        });
    }
}
exports.default = Parcel;
